// 中央 HUD パーツ (= DDSIM-27 Pass 2): フェーズ表示帯 + ターン/手番 バッジ。
//
// PhaseStrip: 7 フェーズ (Start→Refresh→Draw→Charge→Main→Battle→End) を横帯で並べ、
//   current_phase をハイライト。 通過済みは dim、 これからは中間色。
// TurnHud: TURN 番号 + 手番 (YOUR / OPP) バッジ。

// engine `Phase` enum の固定順序 (= crates/engine/src/phase.rs)。
// unit variant なので snapshot.current_phase は bare 文字列 ("Start" 等) で一致する。
const PHASE_ORDER = [
  "Start",
  "Refresh",
  "Draw",
  "Charge",
  "Main",
  "Battle",
  "End",
] as const;

// フェーズ表示帯: 全 7 フェーズを 1 列で表示し、 現在地をハイライトする。
export function PhaseStrip(props: {
  current: string;
  inGame: boolean;
}): JSX.Element {
  const { current, inGame } = props;
  const currentIdx = PHASE_ORDER.indexOf(current as (typeof PHASE_ORDER)[number]);
  return (
    <div className="flex items-center justify-center gap-0.5">
      {PHASE_ORDER.map((phase, i) => {
        const isCurrent = inGame && phase === current;
        const isPast = inGame && currentIdx >= 0 && i < currentIdx;
        const cls = isCurrent
          ? "bg-cyan-500 font-bold text-slate-900"
          : isPast
            ? "text-slate-600"
            : "text-slate-400";
        return (
          <span
            key={phase}
            className={`rounded px-1.5 py-0.5 text-[10px] uppercase leading-none ${cls}`}
          >
            {phase}
          </span>
        );
      })}
    </div>
  );
}

// ターン/手番 HUD: TURN 番号 + どちらの手番か (in-game 中のみ手番バッジを出す)。
export function TurnHud(props: {
  turn: number;
  isMyTurn: boolean;
  inGame: boolean;
}): JSX.Element {
  const { turn, isMyTurn, inGame } = props;
  return (
    <div className="flex items-center gap-2">
      <span className="rounded bg-slate-700 px-2 py-0.5 text-xs font-bold text-slate-200">
        TURN {turn}
      </span>
      {inGame && (
        <span
          className={`rounded px-2 py-0.5 text-xs font-bold ${
            isMyTurn
              ? "bg-emerald-600 text-white"
              : "bg-rose-700/70 text-rose-100"
          }`}
        >
          {isMyTurn ? "YOUR TURN" : "OPP TURN"}
        </span>
      )}
    </div>
  );
}
